import assets from "lib/assets/components";

/**
 * {
 *     type: 'TYPE', // widget type
 *     name: 'Name' // display name
 *     style: {}, // css inline styles
 *     value: '', // model value if any
 * }
 */

export const domConfig = {
  boxModel: true,
  id: {
    label: "ID",
  },
  className: {
    label: "Class names",
  },
  dimensions: true,
  background: true,
  fontColor: true,
  fontFamily: true,
  border: true,
  borderRadius: true,
};

const schema = [
  {
    name: "Containers",
    config: domConfig,
    setup: (c) => {
      if (!c.children) c.children = [];
    },
    components: [
      {
        name: "Vertical List",
        type: "LIST",
        component: () => (
          <div
            style={{
              border: "2px solid #888",
              height: "80%",
              display: "flex",
              alignItems: "center",
              width: "60%",
              margin: "auto",
            }}
          >
            <div
              style={{
                borderStyle: "solid",
                borderWidth: "2px 0 2px 0",
                borderColor: "#888",
                height: "40%",
                flex: 1,
              }}
            ></div>
          </div>
        ),
      },
      {
        name: "Horizontal List",
        type: "LIST",
        component: () => (
          <div
            style={{ border: "2px solid #888", height: "80%", width: "60%" }}
          >
            <div
              style={{
                borderStyle: "solid",
                borderWidth: "0 2px 0 2px",
                borderColor: "#888",
                height: "100%",
                margin: "0 auto",
                width: "33%",
              }}
            ></div>
          </div>
        ),
      },
    ],
  },
  {
    name: "Elements",
    config: domConfig,
    components: [
      {
        name: "Div",
        type: "DIV",
      },
    ],
  },
  {
    name: "Typography",
    config: domConfig,
    components: [
      {
        name: "Heading",
        type: "HEADING",
        component: () => <img src={assets.heading} alt="" />,
      },
      {
        name: "Link",
        type: "LINK",
        config: {
          link: {
            label: "Link",
          },
          value: {
            label: "Label",
          },
        },
        component: () => <img src={assets.link} alt="" />,
      },
      {
        name: "Text",
        type: "TEXT",
        component: () => <img src={assets.text} alt="" />,
      },
    ],
  },
  {
    name: "Controls",
    config: {
      ...domConfig,
      code: true,
      draggable: true,
    },
    components: [
      {
        name: "Button",
        type: "BUTTON",
        component: () => <img src={assets.button} alt="" />,
      },
    ],
  },
  {
    name: "Form",
    config: domConfig,
    components: [
      {
        name: "Input",
        type: "INPUT",
        component: () => <img src={assets.input} alt="" />,
      },
      {
        name: "Textarea",
        type: "TEXTAREA",
        component: () => <img src={assets.textarea} alt="" />,
      },
    ],
  },
  {
    name: "Others",
    config: domConfig,
    components: [
      {
        name: "Panel",
        type: "PANEL",
      },
      {
        name: "Map",
        type: "MAP",
        component: () => <img src={assets.map} alt="" />,
        config: {
          dimensions: true,
          center: {
            label: "Center",
          },
          zoom: {
            label: "Zoom",
          },
        },
      },
      {
        name: "Table",
        type: "TABLE",
        component: () => <img src={assets.table} alt="" />,
      },
    ],
  },
];

export default schema;
